// file: src/pages/landing/components/ProjectCard.jsx
import React from 'react';
import { Package, Trash2 } from 'lucide-react';
import styles from './ProjectCard.module.css';

/**
 * ProjectCard component displays an individual project card with delete functionality
 * @param {Object} project - The project object to display
 * @param {Function} onClick - Callback when project card is clicked
 * @param {Function} onDelete - Callback when delete button is clicked
 */
function ProjectCard({ project, onClick, onDelete }) {
  // Try to use updated_at, created_at, or fallback to today
  let lastEdited = project.updated_at || project.modified_at || project.created_at;
  let lastEditedDate = lastEdited ? new Date(lastEdited) : new Date();
  
  return (
    <div
      className={styles.projectCard}
      onClick={onClick}
    >
      <div className={styles.projectCardContent}>
        {/* Project preview area */}
        <div className={styles.projectPreview}>
          <div className={styles.projectIcon}>
            <Package className="h-4 w-4" />
          </div>
          
          {/* Delete button - positioned absolutely in top-right */}
          <button
            onClick={onDelete}
            className={styles.deleteButton}
            title="Delete project"
          >
            <Trash2 className={styles.deleteIcon} />
          </button>
        </div>
        
        {/* Project info */}
        <div className={styles.projectInfo}>
          <h3 className={styles.projectName}>
            {project.name}
          </h3>
          <p className={styles.projectDate}>
            {lastEditedDate.toLocaleDateString()}
          </p>
        </div>
      </div>
    </div>
  );
}

export default ProjectCard;
